import { useAccountApplicationsQuery } from './useAccountApplicationsQuery';
import { useAccountApplicationsSearch } from './useAccountApplicationsSearch';
import { AccountApplication } from '../types';

export const useAccountApplications = (accountId: string) => {

    if (typeof accountId === 'undefined') {
        throw new Error('accountId is required parameter');
    }

    const { data, isLoading: loading } = useAccountApplicationsQuery({ accountId });
    const { keyword } = useAccountApplicationsSearch();

    const items = data?.items || [];

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter((item: AccountApplication) =>
        !keyword ||
        item.applicationId?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.application?.name?.toLowerCase().includes(keyword.toLowerCase())
    );

    const visibleCount = visibleItems.length;

    return {
        items,
        visibleItems,
        visibleCount,
        loading,
    };
};
